export const BASE_URL = "https://api.telegram.org/bot";
export const MARKDOWN = "Markdown";
export const GET_ME = "/getMe";
export const GET_UPDATES = "/getUpdates";
export const GET_FILE = "/getFile";
export const GET_CHAT_ADMINISTRATORS = "/getChatAdministrators";
export const SEND_MESSAGE = "/sendMessage";
export const SEND_VENUE = "/sendVenue";
export const SEND_DOCUMENT = "/sendDocument";
export const SEND_VOICE = "/sendVoice";
export const SEND_VIDEO = "/sendVideo";
export const SEND_AUDIO = "/sendAudio";
export const SEND_ANIMATION = "/sendAnimation";
export const SEND_VIDEO_NOTE = "/sendVideoNote";
export const SEND_POLL = "/sendPoll";
export const SEND_PHOTO = "/sendPhoto";
export const SEND_CONTACT = "/sendContact";
export const SEND_DICE = "/sendDice";
export const SEND_LOCATION = "/sendLocation";
